import { NgModule } from '@angular/core';
import { HowToPersonaliseContentModalComponent } from "./how-to-personalise-content-modal.component";
import {ButtonModule} from "@xref/xref-lib";
import {CommonModule} from "@angular/common";

@NgModule({
    declarations: [HowToPersonaliseContentModalComponent],
    imports: [CommonModule, ButtonModule],
    exports: [HowToPersonaliseContentModalComponent],
})

export class HowToPersonaliseContentModalModule {}